<template>
  <v-bottom-sheet :value="value" @input="$emit('input', $event)" dark inset max-width="640">
    <v-sheet class="read-receipts-sheet">
      <header class="read-receipts-header">
        <div>
          <h2 class="read-receipts-title">Lesestatus</h2>
          <p class="read-receipts-subtitle">Für diese Nachricht</p>
        </div>
        <v-btn icon class="read-receipts-close" aria-label="Lesestatus schliessen" @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </header>

      <v-tabs v-model="tab" class="read-receipts-tabs" background-color="transparent" color="#8cddb0" grow>
        <v-tab>Gelesen <span class="read-receipts-count">{{ readByList.length }}</span></v-tab>
        <v-tab>Noch nicht <span class="read-receipts-count">{{ notReadByList.length }}</span></v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="read-receipts-content">
        <v-tab-item>
          <template v-if="readByList.length > 0">
            <p class="read-receipts-caption">Zuletzt gelesen</p>
            <ul class="read-receipts-list" aria-label="Gelesen von">
              <li v-for="receipt in sortedReadBy" :key="receipt.userId._id" class="read-receipts-row">
                <v-avatar size="44" class="read-receipts-avatar">
                  <v-img v-if="receipt.userId.bild" :src="'/img/profilbilder/' + receipt.userId.bild" alt=""></v-img>
                  <span v-else>{{ getInitials(receipt.userId) }}</span>
                </v-avatar>
                <div class="read-receipts-person">
                  <span class="read-receipts-name">{{ receipt.userId.vorname }} {{ receipt.userId.nachname }}</span>
                  <span class="read-receipts-time">{{ formatReadTime(receipt.readAt) }}</span>
                </div>
                <v-icon class="read-receipts-check" size="20" aria-hidden="true">mdi-check-all</v-icon>
              </li>
            </ul>
          </template>
          <div v-else class="read-receipts-empty">
            <v-icon size="32" aria-hidden="true">mdi-eye-outline</v-icon>
            <p>Noch keine Lesebestätigung</p>
            <span>Sobald jemand die Nachricht liest, erscheint die Person hier.</span>
          </div>
        </v-tab-item>

        <v-tab-item>
          <template v-if="notReadByList.length > 0">
            <p class="read-receipts-caption">Lesebestätigung ausstehend</p>
            <ul class="read-receipts-list" aria-label="Noch nicht gelesen von">
              <li v-for="member in notReadByList" :key="member.userId._id" class="read-receipts-row">
                <v-avatar size="44" class="read-receipts-avatar">
                  <v-img v-if="member.userId.bild" :src="'/img/profilbilder/' + member.userId.bild" alt=""></v-img>
                  <span v-else>{{ getInitials(member.userId) }}</span>
                </v-avatar>
                <div class="read-receipts-person">
                  <span class="read-receipts-name">{{ member.userId.vorname }} {{ member.userId.nachname }}</span>
                </div>
              </li>
            </ul>
          </template>
          <div v-else class="read-receipts-empty">
            <v-icon size="32" class="read-receipts-check" aria-hidden="true">mdi-check-all</v-icon>
            <p>Von allen gelesen</p>
            <span>Es sind keine Lesebestätigungen mehr offen.</span>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "ReadReceiptsDialog",
  props: {
    value: Boolean, // v-model
    readBy: {
      // Das 'message.readBy'-Array
      type: Array,
      default: () => [],
    },
    members: {
      // NEU: Das 'activeGroupData.members'-Array
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: 0, // Startet auf dem "Gelesen"-Tab
    }
  },
  computed: {
    // Holt den eingeloggten User, um ihn rauszufiltern
    ...mapState("userStore", ["user"]),

    // Stellt sicher, dass 'readBy' einheitliche Objekte hat
    readByList() {
      return this.readBy || []
    },

    // Sortiert die "Gelesen"-Liste
    sortedReadBy() {
      return [...this.readByList].sort((a, b) => new Date(b.readAt) - new Date(a.readAt))
    },

    // NEU: Berechnet, wer noch fehlt
    notReadByList() {
      if (!this.members || !this.user) return []

      // 1. Hol alle IDs derer, die gelesen haben
      const readerIds = new Set(this.readByList.map((receipt) => receipt.userId._id || receipt.userId))

      // 2. Filtere die Mitgliederliste
      return this.members.filter((member) => {
        // 3. Zeige nicht dich selbst
        if (member.userId._id === this.user._id) return false
        // 4. Zeige nur die, die NICHT in der 'readerIds'-Liste sind
        return !readerIds.has(member.userId._id)
      })
    },
  },
  methods: {
    getInitials(user) {
      if (!user) return "?"
      const v = user.vorname || ""
      const n = user.nachname || ""
      return `${v.charAt(0).toUpperCase()}${n.charAt(0).toUpperCase()}`
    },

    formatReadTime(timestamp) {
      const date = new Date(timestamp)
      // TODO: Bessere Datums-Formatierung (z.B. "Heute um 14:31")
      return date.toLocaleString("de-CH", {
        dateStyle: "short",
        timeStyle: "short",
      })
    },
  },
}
</script>

<style scoped>
.read-receipts-sheet {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  max-height: 90dvh;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 0;
  border-radius: 24px 24px 0 0;
  background: #1e1e1e;
  color: #f2f4f3;
  font-size: 1rem;
  text-align: left;
}

.read-receipts-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 24px 16px;
  flex: 0 0 auto;
}

.read-receipts-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.4;
}

.read-receipts-sheet .read-receipts-subtitle {
  margin: 4px 0 0;
  color: #adb5b0;
  font-size: 0.875rem;
  line-height: 1.5;
}

.read-receipts-close {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.06);
}

.read-receipts-tabs {
  flex: 0 0 auto;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.read-receipts-tabs ::v-deep .v-tab {
  gap: 8px;
  min-width: 0;
  padding: 0 12px;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: normal;
  text-transform: none;
}

.read-receipts-count {
  min-width: 24px;
  padding: 2px 7px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
  line-height: 1.5;
}

.read-receipts-tabs ::v-deep .v-tab--active .read-receipts-count {
  background: rgba(140, 221, 176, 0.12);
}

.read-receipts-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
  background: transparent;
  scrollbar-width: thin;
  scrollbar-color: #626a65 transparent;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.read-receipts-sheet .read-receipts-caption {
  margin: 0;
  padding: 20px 24px 8px;
  color: #adb5b0;
  font-size: 0.875rem;
  line-height: 1.5;
}

.read-receipts-sheet .read-receipts-list {
  margin: 0;
  padding: 0 24px 16px;
  list-style: none;
}

.read-receipts-row {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 72px;
  padding: 12px 0;
}

.read-receipts-row + .read-receipts-row {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.read-receipts-avatar {
  flex: 0 0 auto;
  background: #303e35;
  color: #b8e1c8;
  font-size: 0.875rem;
  font-weight: 600;
}

.read-receipts-person {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.read-receipts-name {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.read-receipts-time {
  color: #adb5b0;
  font-size: 0.875rem;
  font-variant-numeric: tabular-nums;
  line-height: 1.5;
}

.read-receipts-sheet .read-receipts-check {
  flex: 0 0 auto;
  color: #8cddb0;
}

.read-receipts-empty {
  padding: 40px 24px;
  text-align: center;
}

.read-receipts-sheet .read-receipts-empty p {
  margin: 16px 0 6px;
  font-size: 1rem;
  font-weight: 600;
}

.read-receipts-empty span {
  display: block;
  color: #adb5b0;
  font-size: 0.875rem;
  line-height: 1.5;
}

@media (max-width: 400px) {
  .read-receipts-header {
    padding: 20px 16px 16px;
  }

  .read-receipts-sheet .read-receipts-caption {
    padding-right: 16px;
    padding-left: 16px;
  }

  .read-receipts-sheet .read-receipts-list {
    padding-right: 16px;
    padding-left: 16px;
  }
}
</style>
